/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as CheckIcon } from "src/assets/static/images/checkicon.svg";
import { ReactComponent as RightArrow } from "src/assets/static/images/rightarrow.svg";
import { ReactComponent as LeftArrow } from "src/assets/static/images/leftarrow.svg";
import { ReactComponent as GroupYellowIcon } from "src/assets/static/images/header/group.svg";
import { useDispatch, useSelector } from "react-redux";
import actions from "src/store/common/actions";
import useFormatById from "src/hooks/utils/useFormatById";
import {
  CLIENT_BLOGS,
  CLIENT_CHATBOT,
  CLIENT_CORP_INSURANCE,
  CLIENT_INSURANCE_AND_MORE,
  CLIENT_SAERTO,
  CLIENT_STUDENT,
  CLIENT_TRAVEL,
  CLIENT_INSIDE_TRAVEL,
  CLIENT_UNO,
  TEMPORARY_REIMB,
  TEMPORARY_PROFILE_DOCTOR,
  TEMPORARY_APPEALS,
  CLIENT_OFFERS,
  CLIENT_CAR,
  CLIENT_UNO_ACTIVE,
  CLIENT_UNO_COMFORT,
} from "src/containers/layout";
import LanguageSwitcher from "./languageSwitcher";

const SidebarToggle = ({ setOpenSideBar, sideBarClose, isOpen }) => {
  const [currLangIsEng, setCurrLangIsEng] = useState(false);
  const f = useFormatById();
  const imedilLink = process.env.REACT_APP_CLIENT_MAIN_URL;
  const profileLink = process.env.REACT_APP_IMEDIL_LINK;
  const dispatch = useDispatch();

  const changeLang = (lang) => {
    lang === "en" ? setCurrLangIsEng(true) : setCurrLangIsEng(false);
    localStorage.setItem("lang", lang);
    dispatch(actions.setLanguage(lang));
  };

  const lang = useSelector((state) => state.common.lang);

  useEffect(() => {
    lang === "en" ? setCurrLangIsEng(true) : setCurrLangIsEng(false);
  }, [lang]);

  const [openProducts, setOpenProducts] = useState(false);
  const [openDistant, setOpenDistant] = useState(false);

  return (
    <>
      <div className={`dark-overlay ${isOpen ? "opened" : ""}`}></div>
      <div className={`overlay ${isOpen ? "opened" : ""}`} ref={sideBarClose}>
        <div className="overlay-content">
          {!openProducts && !openDistant && (
            <>
              <Link className="ms-3 " onClick={() => setOpenProducts(true)}>
                {f("topbar.InsuranceProducts")}
                <RightArrow className="float-end me-1" />
              </Link>
              <Link className="ms-3" onClick={() => setOpenDistant(true)}>
                <span className="online-services-styles ">
                  {f("topbar.OnlineServices")}
                </span>
                <span>
                  <RightArrow className="float-end me-1" />
                </span>
              </Link>
              <Link
                className="ms-3"
                to={`${imedilLink}/${CLIENT_OFFERS}/${lang}`}
                onClick={() => setOpenSideBar(false)}
              >
                {f("main.offers")}
              </Link>
              <Link
                className="ms-3"
                to={`${imedilLink}/${CLIENT_BLOGS}/${lang}`}
                onClick={() => setOpenSideBar(false)}
              >
                {f("topbar.news")}
              </Link>
            </>
          )}
          {openProducts && (
            <>
              <Link
                onClick={() => setOpenProducts(false)}
                className="ps-5 header-link"
              >
                <LeftArrow />
                <span className="ms-4">{f("topbar.InsuranceProducts")}</span>
              </Link>
              <h3 className="ms-3">{f("topbar.forYou")}</h3>
              <Link
                className="ms-3 "
                to={`${imedilLink}/${CLIENT_CAR}/${lang}`}
                onClick={() => setOpenSideBar(false)}
              >
                {f("topbar.autoInsurance")}
              </Link>
              <Link
                className="ms-3"
                onClick={() => setOpenSideBar(false)}
                to={`${imedilLink}/${CLIENT_UNO}/${lang}`}
              >
                {f("topbar.HealthInsurance")}
              </Link>
              <Link
                className="ps-5 secondary-link"
                to={`${imedilLink}/${CLIENT_UNO_ACTIVE}/${lang}`}
                onClick={() => setOpenSideBar(false)}
              >
                <GroupYellowIcon /> {f("topbar.unoActive")}
              </Link>
              {/* <Link
                className="ps-5 secondary-link"
                to={`${imedilLink}/${CLIENT_UNO_COMFORT}/${lang}`}
                onClick={() => setOpenSideBar(false)}
              >
                <GroupYellowIcon /> {f("topbar.unoComfort")}
              </Link> */}
              <Link
                className="ms-3"
                to={`${imedilLink}/${CLIENT_TRAVEL}/${lang}`}
                onClick={() => setOpenSideBar(false)}
              >
                {f("topbar.TravelInsurance")}
              </Link>
              <Link
                className="ms-3"
                to={`${imedilLink}/${CLIENT_INSURANCE_AND_MORE}/${lang}`}
                onClick={() => setOpenSideBar(false)}
              >
                {f("topbar.InsuranceAndMore")}
              </Link>

              <h3 className="ms-3">{f("topbar.forBusiness")}</h3>
              <Link
                className="ms-3"
                to={`${imedilLink}/${CLIENT_CORP_INSURANCE}/${lang}`}
                onClick={() => setOpenSideBar(false)}
              >
                {f("topbar.HealthInsurance")}
              </Link>

              <h3 className="ms-3">{f("topbar.forForeign")}</h3>
              <Link
                className="ms-3"
                to={`${imedilLink}/${CLIENT_STUDENT}/${lang}`}
                onClick={() => setOpenSideBar(false)}
              >
                {f("topbar.ForeignStudentsInsurance")}
              </Link>
              <Link
                className="ms-3"
                to={`${imedilLink}/${CLIENT_INSIDE_TRAVEL}/${lang}`}
                onClick={() => setOpenSideBar(false)}
              >
                {f("topbar.InsideTravelInsurance")}
              </Link>
            </>
          )}
          {openDistant && (
            <>
              <Link
                // style={{ backgroundColor: "#709DD0" }}
                onClick={() => {
                  setOpenDistant(false);
                }}
                className="ps-5 header-link"
              >
                <LeftArrow />
                <span className="ms-4">{f("topbar.OnlineServices")}</span>
              </Link>
              <Link
                to={`${profileLink}${TEMPORARY_PROFILE_DOCTOR}/${lang}`}
                className="ms-3"
                onClick={() => setOpenSideBar(false)}
              >
                {f("topbar.FamilyReservationToDoc")}
              </Link>

              <Link
                to={`${profileLink}${TEMPORARY_REIMB}/${lang}`}
                className="ms-3"
                onClick={() => setOpenSideBar(false)}
              >
                {f("main.claimForReimbursement")}
              </Link>
              <Link
                to={`${profileLink}${TEMPORARY_APPEALS}/${lang}`}
                className="ms-3"
                onClick={() => setOpenSideBar(false)}
              >
                {f("main.distantCalls")}
              </Link>
              <a
                className="ms-3"
                href={`https://www.facebook.com/imediL?mibextid=LQQJ4d`}
                target="_blank"
                onClick={() => setOpenSideBar(false)}
              >
                {f("topbar.ImedilBot")}
              </a>
            </>
          )}
        </div>
        <div className="languages-div  ps-4">
          {/* <LanguageSwitcher /> */}
          <div className="top-border">
            <div className="ms-2 me-3">
              <hr />
            </div>
            <p onClick={() => changeLang("ge")}>
              ქართული{" "}
              {!currLangIsEng && <CheckIcon className="float-end me-2" />}
            </p>
            <p onClick={() => changeLang("en")}>
              English{" "}
              {currLangIsEng && <CheckIcon className="float-end me-2" />}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default SidebarToggle;
